<template>
    <v-container fluid>
        <v-card color="#6499faff" dark class="rounded-xl">
            <v-card-title>
                <v-row align="center">
                    <v-col cols="12" lg="4">
                        {{ $t('menu.coaches') }}
                    </v-col>
                    <!-- <v-col cols="12">
                        <coach-filters @setFilters="setFilters"/>
                    </v-col> -->
                    <v-col cols="12" align="end">
                        <v-btn class="my-2 mr-2" dark small color="black" @click="createCoach">
                            <v-icon dark>mdi-plus</v-icon>{{ $t('button.create') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <array-view
            :items="coaches"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :type="'coach'"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @onDelete="onDelete"
        />
    </v-container>
</template>

<script>
    import coachService from '@/services/coach'
    import ArrayView from '@/components/ArrayView'
    // import CoachFilters from '@/components/CoachFilters'

    export default {
        name: 'Coach',
        components: { ArrayView },
        data: () => {
            return {
                coaches: [],
                displayInfo: [
                    { text: 'table.id', value: 'id' },
                    { text: 'table.firstName', value: 'name' },
                    { text: 'table.lastName', value: 'lastName' },
                    { text: 'table.mobilePhone', value: 'mobile' },
                    { text: 'table.email', value: 'email' }
                ],
                size: 100,
                totalPages: 0,
                page: 1,
                loading: false,
                filters: null,
                message: null
            }
        },
        watch: {
            filters: {
                handler() {
                    this.fetchFilteredCoaches()
                }
            }
        },
        created() {
            this.filters = this.$store.getters.getCoachFilters
            this.page = this.$store.getters.getPage
            this.fetchFilteredCoaches()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchFilteredCoaches()
            },
            handleClick(action, item) {
                this.$router.push(`/coaches/${item.id}/${action}`)
            },
            createCoach() {
                this.$router.push(`/coaches/create`)
            },
            onDelete(item, page) {
                coachService.deleteCoach(item.id).then(() => {
                    this.page = page
                    this.fetchFilteredCoaches()
                })
            },
            setFilters(filters) {
                this.filters = filters
                this.$store.dispatch('setCoachFilters', this.filters)
            },
            fetchFilteredCoaches() {
                this.loading = true
                coachService.getFilteredCoaches(this.filters, this.page, this.size).then(resp => {
                    this.coaches = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
